<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  import MtaH5 from 'mta-h5-analysis'
  // import Vue from 'vue'
  // import Raven from 'raven-js'
  // import RavenVue from 'raven-js/plugins/vue'

  // Raven
  //     .config('https://3d86cb3b7dbc478aaa6a790daaa11a4f@sentry.qidian.com/26')
  //     .addPlugin(RavenVue, Vue)
  //     .install()
  export default {
    name: 'app',
    created () {
      // 初始化mta统计代码
      MtaH5.init({
        'sid': global.MTA_SID, // 必填，统计用的appid
        'cid': global.MTA_CID, // 如果开启自定义事件，此项目为必填，否则不填
        'autoReport': 1, // 是否开启自动上报(1:init完成则上报一次,0:使用pgv方法才上报)
        'senseHash': 1, // hash锚点是否进入url统计
        'senseQuery': 1, // url参数是否进入url统计
        'performanceMonitor': 1, // 是否开启性能监控
        'ignoreParams': [] // 开启url参数上报时，可忽略部分参数拼接上报
      })

      if (process.env.NODE_ENV === 'development') {
        import(/* webpackChunkName: "eruda" */ 'eruda').then(eruda => {
          eruda.init()
        })
      }
    }
  }
</script>

<style src="@v2/assets/css/reset.module.css"></style>
<style src="@v2/assets/css/base.module.css"></style>
<style src="@v2/assets/css/modal.module.css"></style>
<style src="@v2/assets/css/QD_A.module.css"></style>
<style src="@v2/assets/css/skin.module.css"></style>
<style src="@v2/assets/css/hack.module.css"></style>


// WEBPACK FOOTER //
// App.vue?1a5e122e